// [server-parity-web-2026-10-05] PLATFORM SHIM
// Single place that answers "are we inside the Capacitor shell, and which one?"
// so src/server-app.jsx can be the one source for both the web deploy
// (app.calegalexpress.com) and the native iOS app (strikeserve-mobile).
//
// Every accessor is defensive: it never throws, and on plain web every native
// answer is falsy / null so the browser fallbacks in server-app.jsx run exactly
// as before. Nothing here imports @capacitor/* — the bridge is read off
// window.Capacitor, which is how the hand-bundled webview exposes it.

/* The bundler target this file was built for ("web" | "native"). build.sh passes
   --define:__SS_TARGET__; a bare `npx esbuild` run (no define) falls back to "web". */
export const BUILD_TARGET = (() => {
  try { return typeof __SS_TARGET__ !== "undefined" ? String(__SS_TARGET__) : "web"; } // eslint-disable-line no-undef
  catch (_) { return "web"; }
})();

/* The raw Capacitor bridge, or null. */
export function cap() {
  try { return (typeof window !== "undefined" && window.Capacitor) || null; }
  catch (_) { return null; }
}

/* True only inside a real native shell (iOS / Android). A Capacitor bridge
   present on web (capacitor-bootstrap.js on the Netlify deploy) reports false. */
export function isNative() {
  const c = cap();
  try { return !!(c && typeof c.isNativePlatform === "function" && c.isNativePlatform()); }
  catch (_) { return false; }
}

/* "ios" | "android" | "web" */
export function platform() {
  const c = cap();
  try { if (c && typeof c.getPlatform === "function") return String(c.getPlatform() || "web"); }
  catch (_) { /* fall through */ }
  return "web";
}

/* A Capacitor plugin by name (window.Capacitor.Plugins[name]) or null. Callers
   keep their own browser fallback for the null case. */
export function plugin(name) {
  const c = cap();
  try { return (c && c.Plugins && c.Plugins[name]) || null; }
  catch (_) { return null; }
}

/* [ios-no-purchase-2026-10-05] App Store Guideline 3.1.1: the iOS app shows no
   way to buy, upgrade, subscribe or manage billing. Existing plans still display
   (read-only) and paid features keep working for subscribers. Web and Android
   are unchanged. */
export function noPurchase() {
  return platform() === "ios";
}

/* How the brand chrome resolves its tenant:
   - "web"      : by the serving domain (fetch /api/tenant/config, Origin decides)
   - "tenant"   : native shell that declared a tenant slug via window.__SS_TENANT
   - "platform" : native shell with no tenant — StrikeServe defaults, no fetch */
export function brandMode() {
  if (!isNative()) return "web";
  try {
    if (typeof window !== "undefined" && typeof window.__SS_TENANT === "string" && window.__SS_TENANT.trim()) return "tenant";
  } catch (_) { /* ignore */ }
  return "platform";
}

/* The tenant slug the native bootstrap declared, or "". */
export function tenantSlug() {
  try {
    if (typeof window !== "undefined" && typeof window.__SS_TENANT === "string") return window.__SS_TENANT.trim();
  } catch (_) { /* ignore */ }
  return "";
}
